export const generateRevtrackLink = (baseUrl, linkType, resourceValue, splitTestPageId = null) => {
    // Function to check if URL ends with a common domain extension without a trailing slash
    const needsSlash = (url) => {
        const commonDomainEndings = ['.com', '.org', '.net', '.io', '.app', '.co', '.dev', '.ai', '.edu', '.gov'];
        return commonDomainEndings.some(ending => url.endsWith(ending));
    };

    let utmLink;
    
    // Determine parameter name based on link type
    const paramName = linkType === 'pinComment' ? 'pinComment' : 
                     (linkType === 'youtube' ? 'video' : 
                     (linkType === 'email' ? 'rtemail' : linkType));

    // Build the base URL with parameters
    if (baseUrl.includes('?')) {
        utmLink = `${baseUrl}&${paramName}=${encodeURIComponent(resourceValue)}`;
    } else {
        utmLink = needsSlash(baseUrl)
            ? `${baseUrl}/?${paramName}=${encodeURIComponent(resourceValue)}`
            : `${baseUrl}?${paramName}=${encodeURIComponent(resourceValue)}`;
    }

    // Add split test parameter if provided
    if (splitTestPageId) {
        utmLink += `&split=${encodeURIComponent(splitTestPageId)}`;
    }

    return utmLink;
};

export const extractVideoId = (url) => {
    // Handle YouTube live links (format: youtube.com/live/VIDEO_ID)
    const liveRegex = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/live\/([^&\n?#]+)/;
    const liveMatch = url.match(liveRegex);
    if (liveMatch) {
        return liveMatch[1];
    }
    
    // Handle standard YouTube links
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|.+\?v=)?|youtu\.be\/)([^&\n?#]+)/;
    const match = url.match(regex);
    return match ? match[1] : null;
};
